export default __webpack_public_path__ + "static/media/Lady.464e9944.svg";